import { render, staticRenderFns } from "./BpTotalAssetsNumberDisplayer.vue?vue&type=template&id=384725c7"
import script from "./BpTotalAssetsNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpTotalAssetsNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports